// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2BSe8","footer":"ChangeClinic_footer__1Z5iw"};